import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import { uiDateFormat } from '../../../constants/date';
import spinner from '../../../images/spinner.gif';
import { taxTypes } from '../../../constants/companies';
import Radio from '../../common/forms/Radio';

export default class UpdateInterview extends Component {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    interview: PropTypes.object,
    interview_comment: PropTypes.string,
    interviewDecision: PropTypes.string,
    handleChangeDecision: PropTypes.func.isRequired,
    handleChangeComment: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    submitInterviewDecision: PropTypes.func.isRequired,
    tax_type: PropTypes.string
  };

  render () {
    const { interview, interview_comment, interviewDecision, handleChangeDecision, handleChangeComment,
      submitInterviewDecision, isShown, isLoading, tax_type, onChange } = this.props;
    if (!isShown) {
      return null;
    }
    const decisionIsDecline = interviewDecision === 'decline';
    const isInterviewPassed = interviewDecision === 'pass';
    const submitDecisionIsDisabled = !interviewDecision || (decisionIsDecline && !interview_comment);
    const currentDayTime = moment().format(uiDateFormat);
    return (
      <div className='interview-decision-wrapper'>
        { !interview && <p>{currentDayTime}</p> }
        <p>
          <label>
            <input
              type='radio'
              name='decision'
              value='pass'
              checked={isInterviewPassed}
              onChange={handleChangeDecision}
            />
            Pass
          </label>
        </p>
        <p>
          <label>
            <input
              type='radio'
              name='decision'
              value='decline'
              checked={decisionIsDecline}
              onChange={handleChangeDecision}
            />
            Decline
          </label>
        </p>
        <p>Comment:</p>
        <textarea
          className='input input-textarea'
          placeholder={`Write comment (${decisionIsDecline ? 'required' : 'optional'})`}
          value={interview_comment}
          onChange={handleChangeComment}
        />

        {isInterviewPassed && (
          <div className='form-group mt-3'>
            <div>Tax Type:</div>
            <div className='d-flex'>
              <Radio name={'tax_type'} value={taxTypes.W2} checked={tax_type === taxTypes.W2} onChange={() => onChange('tax_type', taxTypes.W2)} />
              <Radio name={'tax_type'} value={taxTypes.Ten99M} checked={tax_type === taxTypes.Ten99M} onChange={() => onChange('tax_type', taxTypes.Ten99M)} />
            </div>
          </div>
        )}

        { isLoading ? (
          <img className='loading-spinner' src={spinner} alt='spinner' />
        ) : (
          <React.Fragment>
            { decisionIsDecline ? (
              <button
                className={`button button-delete mt-3 ${submitDecisionIsDisabled && 'disabled'}`}
                onClick={() => submitInterviewDecision(false)}
              >
                Decline
              </button>
            ) : (
              <div className='btns-wrapper'>
                <button
                  disabled={submitDecisionIsDisabled}
                  className='button button-primary mr-3 mb-3'
                  onClick={() => submitInterviewDecision(true)}
                >
                  Accept
                </button>
                <button
                  disabled={submitDecisionIsDisabled}
                  className='button button-primary'
                  onClick={() => submitInterviewDecision(false)}
                >
                  Accept & Skip Background
                </button>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/UpdateInterview.js